import Layout from "@/views/Layout";
import index from "@/views/index";
import login from "@/views/login";
import register from "@/views/register";
import types from "@/views/account_type";
import forget from "@/views/forget";
import info from "@/views/info";
import agreement from "@/views/agreement";
import componentsindex from "@/components/index";
import game_management from "@/components/game_management";
import app_management from "@/components/app_management";
import Operational_data from "@/components/Operational_data";
import adorder from "@/components/Operational_data/adorder";
import income from "@/components/Operational_data/income";
import overviewNew from "@/components/Operational_data/overviewNew";
import retainedNew from "@/components/Operational_data/retainedNew";
import game_analyseNew from "@/components/Operational_data/game_analyseNew";

import account_management from "@/components/account_management";
import authentication from "@/components/account_management/authentication";
import Change_Password from "@/components/account_management/Change_Password";

import information from "@/components/account_management/information";

import file from "@/components/file";
import contact from "@/components/contact";

import gameFoundGame from "@/components/games/FoundGame";
import gameInfo from "@/components/games/GameInfo";
import gameInfoGame from "@/components/games/gameinfo/game";
import gameInfoBasic from "@/components/games/gameinfo/basic";
import gameInfoMaterial from "@/components/games/gameinfo/material";
import gameInfoBasicSettings from "@/components/games/gameinfo/Exploit_settings/basic";
import gameInfoPay from "@/components/games/gameinfo/Exploit_settings/pay";
import gameInfoRank from "@/components/games/gameinfo/Exploit_settings/rank";

import foundapp from "@/components/app/Foundapp";
import appInfo from "@/components/app/appInfo";
import appInfoBasic from "@/components/app/appinfo/basic";
import appInfoMaterial from "@/components/app/appinfo/material";
import appInfoBasicSettings from "@/components/app/appinfo/Exploit_settings/basic";
import appInfoPay from "@/components/app/appinfo/Exploit_settings/pay";

export const constantRouterMap = [
  {
    path: "/",
    name: "index",
    redirect: "/index",
    component: Layout,
    meta: {
      title: "index"
    },
    children: [
      {
        path: "/",
        name: "index",
        redirect: "/index",
        component: index,
        meta: {
          title: "index",
          state: "index"
        },
        children: [
          {
            path: "/index",
            component: componentsindex,
            meta: {
              title: "index",
              icon: "video-camera",
              state: "index",
              keepAlive: true
            }
          },
          {
            path: "/game_management",
            component: game_management,
            // redirect:'/game_management',
            meta: {
              title: "GameManagement",
              icon: "upload",
              state: "game_management"
            },
            children: []
          },

          {
            path: "/app_management",
            component: app_management,
            // redirect:'/game_management',
            meta: {
              title: "appManagement",
              icon: "upload",
              state: "app_management"
            },
            children: []
          },

          {
            path: "/Operational_data",
            component: Operational_data,
            redirect: "/Operational_data/income",
            meta: {
              title: "operation",
              state: "Operational_data"
            },
            children: [
              // {
              //   path: "/Operational_data/adincome",
              //   component: () => import('@/components/Operational_data/adincome'),
              //   meta: {
              //     title: 'adincome',
              //     state: 'Operational_data',
              //     key:'1'
              //   },
              // },
              {
                path: "/Operational_data/income",
                component: income,
                meta: {
                  title: "income",
                  state: "Operational_data",
                  key: "1"
                }
              },
              // {
              //   path: "/Operational_data/overview",
              //   component: overview,
              //   meta: {
              //     title: "overview",
              //     state: "Operational_data",
              //     key: "2"
              //   }
              // },
              {
                path: "/Operational_data/overviewNew",
                component: overviewNew,
                meta: {
                  title: "overview",
                  state: "Operational_data",
                  key: "2"
                }
              },
              // {
              //   path: "/Operational_data/retained",
              //   component: retained,
              //   meta: {
              //     title: "retained",
              //     state: "Operational_data",
              //     key: "2"
              //   }
              // },
              {
                path: "/Operational_data/retainedNew",
                component: retainedNew,
                meta: {
                  title: "retained",
                  state: "Operational_data",
                  key: "2"
                }
              },
              // {
              //   path: "/Operational_data/game_analyse",
              //   component: game_analyse,
              //   meta: {
              //     title: "game_analyse",
              //     state: "Operational_data",
              //     key: "2"
              //   }
              // },
              {
                path: "/Operational_data/game_analyseNew",
                component: game_analyseNew,
                meta: {
                  title: "game_analyse",
                  state: "Operational_data",
                  key: "2"
                }
              },
              {
                path: "/Operational_data/adorder",
                component: adorder,
                meta: {
                  title: "adorder",
                  state: "Operational_data",
                  key: "1"
                }
              }
            ]
          },
          {
            path: "/account_management",
            redirect: "/account_management/information",
            component: account_management,
            meta: {
              title: "AccountManagement",
              state: "account_management"
            },
            children: [
              {
                path: "/account_management/information",
                component: information,
                meta: {
                  title: "Info",
                  state: "account_management"
                }
              },
              {
                path: "/account_management/authentication",
                component: authentication,
                meta: {
                  title: "identity",
                  state: "account_management"
                }
              },
              {
                path: "/account_management/Change_Password",
                component: Change_Password,
                meta: {
                  title: "ChangePassword",
                  state: "account_management"
                }
              }
            ]
          },
          {
            path: "/file",
            component: file,
            meta: {
              title: "DeveloperDocument",
              icon: "upload",
              state: "file"
            }
          },
          {
            path: "/contact",
            component: contact,
            meta: {
              title: "contact",
              icon: "upload",
              state: "contact"
            }
          }
        ]
      },

      {
        path: "/FoundGame",
        component: gameFoundGame,
        meta: {
          title: "GameManagement",
          state: "game_management"
        }
      },

      {
        path: "/GameInfo",
        component: gameInfo,
        redirect: "/gameinfo/game",
        meta: {
          title: "GameDetails",
          state: "game_management"
        },
        children: [
          {
            path: "/gameinfo/game",
            component: gameInfoGame,
            meta: {
              title: "GameInfo",
              state: "game_management",
              routers: 1,
              id: 0
            }
          },
          {
            path: "/gameinfo/basic",
            component: gameInfoBasic,
            meta: {
              title: "Info",
              state: "game_management",
              routers: 1,
              id: 1
            }
          },
          {
            path: "/gameinfo/material",
            component: gameInfoMaterial,
            meta: {
              title: "GameMaterial",
              state: "game_management",
              routers: 1,
              id: 2
            }
          },

          {
            path: "/gameinfo/basicSettings",
            component: gameInfoBasicSettings,
            meta: {
              title: "basicSettings",
              state: "game_management",
              routers: 2,
              id: 3
            }
          },
          {
            path: "/gameinfo/pay",
            component: gameInfoPay,
            meta: {
              title: "pay",
              state: "game_management",
              routers: 2,
              id: 4
            }
          },

          {
            path: "/gameinfo/rank",
            component: gameInfoRank,
            meta: {
              title: "rank",
              state: "game_management",
              routers: 2,
              id: 5
            }
          }
        ]
      },

      {
        path: "/Foundapp",
        component: foundapp,
        meta: {
          title: "appManagement",
          state: "app_management"
        }
      },
      {
        path: "/appInfo",
        component: appInfo,
        redirect: "/appinfo/basic",
        meta: {
          title: "appDetails",
          state: "app_management"
        },
        children: [
          {
            path: "/appinfo/basic",
            component: appInfoBasic,
            meta: {
              title: "Info",
              state: "app_management",
              routers: 1,
              id: 0
            }
          },
          {
            path: "/appinfo/material",
            component: appInfoMaterial,
            meta: {
              title: "appMaterial",
              state: "app_management",
              routers: 1,
              id: 1
            }
          },

          {
            path: "/appinfo/basicSettings",
            component: appInfoBasicSettings,
            meta: {
              title: "basicSettings",
              state: "app_management",
              routers: 2,
              id: 2
            }
          },
          {
            path: "/appinfo/pay",
            component: appInfoPay,
            meta: {
              title: "pay",
              state: "app_management",
              routers: 2,
              id: 3
            }
          }
        ]
      },

      {
        path: "/login",
        meta: {
          title: "login",
          state: "login",
          auth: false
        },
        component: login
      },
      {
        path: "/register",
        meta: {
          title: "register",
          state: "register",
          auth: false
        },
        component: register
      },
      {
        path: "/type",
        meta: {
          title: "type",
          state: "type",
          auth: false
        },
        component: types
      },
      {
        path: "/forget",
        meta: {
          title: "ForgetPassword",
          state: "forget",
          auth: false
        },
        component: forget
      },
      {
        path: "/info",
        meta: {
          title: "info",
          state: "info",
          auth: false
        },
        component: info
      },
      {
        path: "/agreement",
        meta: {
          title: "agreement",
          state: "agreement",
          auth: false
        },
        component: agreement
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/routers.js